import React, { useEffect, useState } from 'react'
import { func, instanceOf } from 'prop-types'
import cloneDeep from 'lodash/cloneDeep';

const MapIndexRangeSettings = ({
  indexRange,
  // originalIndexRange,
  // handleIndexRangeChange
  mapSettings,
  runReport,
  updateMapSettings,
}) => {
  const [min, setMin] = useState(indexRange[0]);
  const [max, setMax] = useState(indexRange[1]);
  const [exclude, setExclude] = useState(false);
  const [excludeMin, setExcludeMin] = useState('');
  const [excludeMax, setExcludeMax] = useState('');

  useEffect(() => {
    setMin(indexRange[0])
    setMax(indexRange[1])
  }, indexRange)

  const handleChange = (val, type) => {
    const updatedVal = val !== '' ? Number(val.trim()) : '';
    switch (type) {
      case 'min':
        setMin(updatedVal);
        break;
      case 'max':
        setMax(updatedVal);
        break;
      case 'excludeMin':
        setExcludeMin(updatedVal);
        break;
      case 'excludeMax':
        setExcludeMax(updatedVal);
        break;
      default:
    }
  }

  const applyIndexRange = () => {
    if (min && max) {
      let updatedMapSettings = cloneDeep(mapSettings)
      updatedMapSettings = {
        ...updatedMapSettings,
        minIndex: min > max ? max : min,
        maxIndex: max < min ? min : max,
      }
      updateMapSettings('minIndex', min)
      updateMapSettings('maxIndex', max)
      runReport(undefined, undefined, undefined, undefined, updatedMapSettings)
    }
  }

  const resetIndexRange = () => {
    let updatedMapSettings = cloneDeep(mapSettings)
    updatedMapSettings = {
      ...updatedMapSettings,
      minIndex: undefined,
      maxIndex: undefined,
    }
    updateMapSettings('minIndex', undefined)
    updateMapSettings('maxIndex', undefined)
    runReport(undefined, undefined, undefined, undefined, updatedMapSettings)
  }

  const applyExcludeRange = () => {
    if (excludeMin && excludeMax) {
      const minExclude = excludeMin > excludeMax ? excludeMax : excludeMin
      const maxExclude = excludeMax < excludeMin ? excludeMin : excludeMax
      setExcludeMin(minExclude)
      setExcludeMax(maxExclude)
      updateMapSettings('excludeMinIndex', minExclude)
      updateMapSettings('excludeMaxIndex', maxExclude)
    }
  }

  const onChangeExclude = () => {
    if (exclude) {
      updateMapSettings('excludeMinIndex', undefined)
      updateMapSettings('excludeMaxIndex', undefined)
      setExcludeMin('')
      setExcludeMax('')
      setExclude(false)
    } else {
      setExclude(true)
    }
  }

  return (
    <div className="map--settings-indexRange">
      <div className="map--settings-indexRange__title">Index Range</div>
      <div className="map--settings-indexRange__wrapper">
        <input
          id="min"
          type="number"
          value={min}
          className="map--settings-indexRange__input"
          onChange={e => handleChange(e.target.value, 'min')}
        />
        -
        <input
          id="max"
          type="number"
          value={max}
          className="map--settings-indexRange__input"
          onChange={e => handleChange(e.target.value, 'max')}
        />
        <button
          id="includeApply"
          type="button"
          className="map--settings-indexRange__resetBtn"
          disabled={!min && !max}
          onClick={() => applyIndexRange()}
        >
          Apply
        </button>
        <button
          id="includeReset"
          type="button"
          className="map--settings-indexRange__resetBtn"
          onClick={() => resetIndexRange()}
        >
          Reset
        </button>
      </div>
      <div className="map--settings-exclude__wrapper">
        <div className="map--settings-exclude__checkWrap">
          <input
            type="checkbox"
            id="exclude"
            className="map--settings-exclude__checkbox"
            checked={exclude}
            onChange={() => onChangeExclude()}
          />
          Exclude
        </div>
        <div className="map--settings-exclude__inputWrap">
          <input
            id="excludeMin"
            type="number"
            value={excludeMin}
            className="map--settings-exclude__input"
            onChange={e => handleChange(e.target.value, 'excludeMin')}
            disabled={!exclude}
          />
          -
          <input
            id="excludeMax"
            type="number"
            value={excludeMax}
            className="map--settings-exclude__input"
            onChange={e => handleChange(e.target.value, 'excludeMax')}
            disabled={!exclude}
          />
          <button
            id="excludeApply"
            type="button"
            className="map--settings-exclude__resetBtn"
            disabled={!min && !max}
            onClick={() => applyExcludeRange()}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  )
}

MapIndexRangeSettings.propTypes = {
  indexRange: instanceOf(Array),
  // originalIndexRange: instanceOf(Array),
  // handleIndexRangeChange: func,
  mapSettings: instanceOf(Object),
  runReport: func,
  updateMapSettings: func,
}

export default MapIndexRangeSettings